module.exports = __webpack_public_path__ + "static/media/back.537fb308.jpeg";